export default "__VITE_ASSET__D0jQAyKk__"